<template>
  <div>
    <DataTable
      title="Position Recommendations History"
      :show_delete="false"
      :show_header_filter="false"
      :fields="fields"
      :response="response"
      @edit_click="viewSession"
    />
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'

export default {
  name: 'PositionRecommendations',
  components: {
    DataTable
  },
  data () {
    return {
      response: [],
      fields: [
        {
          name: 'owner',
          value: 'owner'
        },
        {
          name: 'applicant',
          value: 'resource_id',
          component: 'LinkEntity',
          additional_data: { resource_type: 'Applicant' }
        },
        {
          name: 'designator',
          value: 'designator'
        },
        {
          name: 'title',
          value: 'title'
        },
        {
          name: 'created_at',
          value: 'created_at',
          is_time: true
        }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapMutations('modals', ['create']),
    fetchData () {
      this.$caller.request('get', '/stats', 'admin_headers', {
        filter_by_designator: 'position_recommendation',
        sort: '-created_at',
        per: 50,
        page: 1
      }).then(response => {
        this.response = Array.isArray(response) ? response : [response]
      }).catch(err => {
        console.error('Failed to fetch recommendation history:', err)
      })
    },
    viewSession (data) {
      let content = {}
      try {
        content = typeof data.content === 'string' ? JSON.parse(data.content) : (data.content || {})
      } catch (e) {
        content = {}
      }

      if (content.session_id) {
        this.create({
          designator: 'position-recommendation-modal',
          component_name: 'PositionRecommendationModal',
          data: { applicant_id: data.resource_id, applicant_name: '' },
          modal_title: 'תוצאות המלצת משרות',
          modal_width: 1200,
          is_center_modal: true
        })
      }
    }
  }
}
</script>
